import React from 'react'
import { Link, useParams, useSearchParams } from 'react-router-dom'
import Navbar from '../components/navbar'
import hero from '../assets/images/hero/paquetes.jpg'
import Footer from '../components/footer'
import ScrollToTop from '../components/scroll-to-top'
import Paquetescomp from '../components/paquetesall'
import { Helmet } from 'react-helmet-async'

export default function Paquetes() {
    const { shortcutTag } = useParams();
    const [searchParams] = useSearchParams();
    const basedomain = process.env.REACT_APP_BASE_URL;
    const initialShortcutTag = shortcutTag || searchParams.get('shortcut') || searchParams.get('tag') || searchParams.get('categoria') || '';

    return (
        <>
            <Helmet>
                <title>Paquetes y Promociones | Hospital Aranda de La Parra</title>
                <meta name="description" content="Nuestros paquetes médicos han sido diseñados para brindar atención integral y accesible, adaptada a diversas necesidades de salud." />
                <meta property="og:title" content="Paquetes y Promociones | Hospital Aranda de La Parra" />
                <meta property="og:description" content="Nuestros paquetes médicos han sido diseñados para brindar atención integral y accesible, adaptada a diversas necesidades de salud." />
                <meta property="og:image" content={`${basedomain}${hero}`} />
                <meta property="og:url" content={`${basedomain}/paquetes`} />
                <meta property="og:type" content="website" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Paquetes y Promociones | Hospital Aranda de La Parra" />
                <meta name="twitter:description" content="Nuestros paquetes médicos han sido diseñados para brindar atención integral y accesible, adaptada a diversas necesidades de salud." />
                <meta name="twitter:image" content={`${basedomain}${hero}`} />
                <meta itemprop="name" content="Paquetes y Promociones | Hospital Aranda de La Parra" />
                <meta itemprop="description" content="Nuestros paquetes médicos han sido diseñados para brindar atención integral y accesible, adaptada a diversas necesidades de salud." />
                <meta itemprop="image" content={`${basedomain}${hero}`} />
            </Helmet>
            <Navbar />
            <section className="bg-half-170 d-table w-100" style={{ backgroundImage: `url(${hero})`, backgroundPosition: 'center' }}>
                <div className="bg-overlay bg-gradient-overlay"></div>
                <div className="container">
                    <div className="row mt-5 justify-content-center">
                        <div className="col-12">
                            <div className="title-heading text-center">
                                <h5 className="heading fw-semibold mb-0 sub-heading text-white title-dark">Paquetes y Promociones</h5>
                            </div>
                        </div>
                    </div>

                    <div className="position-middle-bottom">
                        <nav aria-label="breadcrumb" className="d-block">
                            <ul className="breadcrumb breadcrumb-muted mb-0 p-0">
                                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Paquetes y Promociones</li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </section>
            <div className="position-relative">
                <div className="shape overflow-hidden text-white">
                    <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                    </svg>
                </div>
            </div>
            <section className="section">
                <div className="container mt-50 mt-60">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <div className="section-title text-center mb-4 pb-2">
                                <h4 className="title mb-3">Paquetes</h4>

                                <p className="text-muted para-desc mx-auto mb-0">
                                    Nuestros paquetes médicos han sido diseñados para brindar atención integral y accesible, adaptada a diversas necesidades de salud. Cada paquete incluye servicios y procedimientos clave, seleccionados por nuestros especialistas para ofrecer un cuidado completo y preventivo. Explora nuestras opciones y encuentra el paquete que mejor se ajuste a tus requerimientos de salud y bienestar.
                                </p>

                            </div>
                        </div>
                    </div>
                    <Paquetescomp initialShortcutTag={initialShortcutTag} />
                </div>
            </section>

            <Footer />

            <ScrollToTop />
        </>
    )
}
